import React from 'react'

import { useFormContext } from 'react-hook-form'

import type { ButtonProps } from '@components/ui/Buttons'
import { Button } from '@components/ui/Buttons'

import { DetailsResetMessage, FormResetConfirmDialog } from './elements'

interface ReactHookFormResetButtonProps
  extends Omit<ButtonProps, 'type' | 'onClick' | 'children'>,
    Partial<Pick<ButtonProps, 'children'>> {
  confirmDialogMessage?: StringOrMessage
  needConfirmOnReset?: boolean
  onReset?: VoidFunction
}

export function ReactHookFormResetButton({
  children = DetailsResetMessage,
  confirmDialogMessage,
  needConfirmOnReset = false,
  onReset,
  variant = 'primaryText',
  ...rest
}: ReactHookFormResetButtonProps) {
  const [open, setOpen] = React.useState(false)
  const { reset } = useFormContext()

  function handleResetRequest() {
    if (needConfirmOnReset) {
      setOpen(true)
    } else {
      handleReset()
    }
  }

  function handleClose() {
    setOpen(false)
  }

  function handleReset() {
    reset()
    onReset?.()
    if (open) {
      setOpen(false)
    }
  }

  return (
    <>
      <Button type="button" variant={variant} onClick={handleResetRequest} {...rest}>
        {children}
      </Button>
      <FormResetConfirmDialog
        descriptionMessage={confirmDialogMessage}
        onClose={handleClose}
        onConfirm={handleReset}
        open={open}
      />
    </>
  )
}
